import helpers from '../../util/helpers';

export default {
  init() {},
  finalize() {
    const header = $('header');
    if (header.length) {
      const headerHeight = 120;
      let lastScroll = $(window).scrollTop();

      helpers.onWindowEvents(() => {
        let scrollTop = $(window).scrollTop();

        if (scrollTop > 80) {
          header.addClass('header-fixed');
        } else {
          header.removeClass('header-fixed');
        }

        // .scroll-beyond
        if ($(window).scrollTop() >= headerHeight) {
          if (lastScroll - scrollTop < 0) {
            // Scrolled up
            header.removeClass('scroll-beyond');
          } else if (lastScroll - scrollTop > 0) {
            // Scrolled down
            header.addClass('scroll-beyond');
          }
        } else {
          header.removeClass('scroll-beyond');
        }
        lastScroll = $(window).scrollTop();
      }, 1, 1, 1, 1);

      $('li.menu-item').on('mouseover', function () {
        let menuItem = $(this);
        let submenuWrapper = $('> .sub-menu', menuItem);

        // grab the menu item's position relative to its positioned parent
        let menuItemPos = menuItem.position();

        // place the submenu in the correct position relevant to the menu item
        submenuWrapper.css({
          top: menuItemPos.top + Math.round(menuItem.outerHeight()),
          left: menuItemPos.left,
        });
      });


      if(helpers.isMobile()) {
        const submenu = $('.sub-menu');
        if (submenu.length) {
          submenu.each(function () {
            const link = $(this).siblings('a');

            link.on('click', function (e) {
              e.preventDefault();
            });
          });
        }
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/modules/header.js